/* eslint-disable @typescript-eslint/no-explicit-any */
import { METRICS_CTI } from "../../constants";

let logger: any = null;

// Dynamic import for browser only
if (typeof window !== "undefined") {
  import("@amzn/santos-barossa-shiraz-logs").then(({ createLogger }) => {
    logger = createLogger(METRICS_CTI as any);
  });
}

export interface ErrorLogParams {
  message: string;
  error?: Error | string | unknown;
  shouldLogToConsole?: boolean;
}

export interface LogParams {
  message: string;
  shouldLogToConsole?: boolean;
}

export const logInfo = (params: LogParams) => {
  if (logger) {
    logger.log(params.message);
  }
  if (params.shouldLogToConsole) {
    console.log(params.message);
  }
};

export const logWarn = (params: LogParams) => {
  if (logger) {
    logger.log(params.message);
  }
  if (params.shouldLogToConsole) {
    console.warn(params.message);
  }
};

export const logError = (params: ErrorLogParams) => {
  if (logger) {
    if (params.error) {
      logger.error(params.message, params.error);
    } else {
      logger.error(params.message);
    }
  }
  if (params.shouldLogToConsole) {
    if (params.error) {
      console.error(params.message, params.error);
    } else {
      console.error(params.message);
    }
  }
};
